// extracted by mini-css-extract-plugin
export default {"list":"contact_information-module___list___b4eab142","vertical":"contact_information-module___vertical___c0793be6"};